export interface SaveFingerprintInput {
  type: string;
  agentId: string;
}

export class GenerateFingerprint {
  readonly type = 'GENERATE_FINGEPRINT';
  constructor() {}
}

export class SaveFingerprint {
  readonly type = 'SAVE_FINGEPRINT';
  constructor(public saveFingerprintInput: SaveFingerprintInput) {}
}

export type Actions = GenerateFingerprint | SaveFingerprint;
